import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="payment-cancel-page">
      <div className="mx-auto h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center">
        <XCircle className="h-7 w-7 text-slate-500" />
      </div>
      <h1 className="mt-6 font-display text-3xl font-bold text-slate-900">Checkout cancelled</h1>
      <p className="mt-2 text-slate-600">No worries — your card wasn't charged. You can try again anytime.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/pricing"><Button className="bg-emerald-900 hover:bg-emerald-800 text-white">Back to pricing</Button></Link>
        <Link to="/dashboard"><Button variant="outline">Go to dashboard</Button></Link>
      </div>
    </div>
  );
}
